import 'react-chat-elements/dist/main.css'
import * as common from "../../../common/common";
import http from "../../../common/http-common";
import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import NewResponseCard from './NewResponseCard'
import CssClass from "../../../Styles/common.module.css";

const PAGE_NAME = "ResponseChat.js_";

// type: file, photo, text, location, video, audio
const NewResponseChat = (props) => {
    // const messageListReferance = createRef();
    const { buttonAuthority } = props;
    //console.log("Button Authority for Chat:", buttonAuthority);
    const [reload, setReload] = useState(false)
    const [responseData, setResponseData] = useState([]);
    const [responseAttachment, setResponseAttachment] = useState([]);
    const [attachment, setAttachment] = useState([]);

    const [showView, setShowView] = useState(false);
    const [showAttachment, setShowAttachment] = useState(false);

    const [cookies] = useCookies([]);
    const [userId] = useState(cookies.USER_ID);
    const [userName] = useState(cookies.USER_NAME);

    useEffect(() => {
        if (props.data !== null) {
            setResponseData(props.data)
        }
    }, [props.data])

    const fileIDList = responseData
    .filter((r) => r.ATTACHMENT_ID != null)
    .map((r) => r.ATTACHMENT_ID)
    .toString(",");
    
    //Deployment File
    const deploymentIDList = responseData
    .filter((r) => r.DEPLOYMENT_ATTACHMENT_ID != null)
    .map((r) => r.DEPLOYMENT_ATTACHMENT_ID)
    .toString(",");

    useEffect(() => {
        let functionName = "";

        try {
            functionName = "Get Ticket Attachment";
  
            props.onLoading(true, "Getting ticket attachment, please wait...");

            // setResponseAttachment([]);
            // const fileID = [];
            const listItems = [];

            // if (responseData.length > 0) {         
            //     responseData.map((attachment) => {
            //         if (attachment.ATTACHMENT_ID !== null) {
            //             fileID.push(attachment.ATTACHMENT_ID)
            //         }
            //     })
            // }
            // const fileIDList = responseData.filter((r) => r.ATTACHMENT_ID != null).map((r) => r.ATTACHMENT_ID).toString(",");

            if (fileIDList !== '') {     

              http
                .get( `api/response/GetAttachmentByList?_attachmentId=${fileIDList}&_user=${userId}`, { timeout: 100000 })
                .then((response) => {
                  if (response.data.length > 0) {
                    response.data.forEach((data) => { 
                      listItems.push({
                        key: data.ATTACHMENT_ID,
                        REFERENCE: data.REFERENCE_ID,
                        ATTACHMENT_ID: data.ATTACHMENT_ID,
                        ATTACHMENT_NAME: data.ATTACHMENT_NAME,
                        ATTACHMENT_PATH: data.ATTACHMENT_PATH,
                      });
                      
                    });
                    setResponseAttachment(listItems); 
                    console.log (listItems) ;
                  }      
                })
                .catch((err) => {
                  toast.error("Error on getting attachment. Please try again1.");
                  common.c_LogWebError(PAGE_NAME, functionName, err);
                })
                .finally(() => {
                  props.onLoading(false, "Loading...");
                });
              }
              // else {
              //   setResponseAttachment([])
              //   props.onLoading(false, "Loading...");
              // }      
        }
        catch(err){
            toast.error("Error on getting attachment. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
        }

    }, [fileIDList, userId])

    // useEffect(() => {    
    //   if (responseData.length > 0) {   
    //     responseData.forEach((data, index) => {
    //       getAttachmentDetails(data.ATTACHMENT_ID, index)
    //     })
    //   }
    // }, [responseData, userId])
    
    // function getAttachmentDetails(attachmentId, index) {
    //   let functionName = "";
  
    //   try {
    //     functionName = "Get Ticket Attachment";
  
    //     props.onLoading(true, "Getting ticket attachment, please wait...");
  
    //     setResponseAttachment([]);

    //     attachment[index] = [];
    //     const listItems = [];
    //     if (attachmentId !== null) {
    //       http
    //       .get(
    //         `api/response/GetAttachment?_attachmentId=${attachmentId}&_user=${userId}`,
    //         { timeout: 100000 }
    //       )
    //       .then((response) => {
    //         if (response.data.length > 0) {
    //           response.data.forEach((data, counter) => { 
    //             listItems.push({
    //               key: counter,
    //               REFERENCE_ID: data.REFERENCE_ID,
    //               ATTACHMENT_ID: data.ATTACHMENT_ID,
    //               ATTACHMENT_NAME: data.ATTACHMENT_NAME,
    //               ATTACHMENT_PATH: data.ATTACHMENT_PATH,
    //             });
    //           });
    //         }
    //         // setResponseAttachment(listItems);
    //         attachment[index].push(listItems);
    //         setResponseAttachment(attachment);
    //       })
    //       .catch((err) => {
    //         toast.error("Error on getting attachment. Please try again.");
    //         common.c_LogWebError(PAGE_NAME, functionName, err);
    //       })
    //       .finally(() => {
    //         props.onLoading(false, "Loading...");
    //       });
    //     }
    //     else {
    //       setResponseAttachment([])
    //       props.onLoading(false, "Loading...");
    //     }     
    //   } catch (err) {
    //     toast.error("Error on getting attachment. Please try again.");
    //     common.c_LogWebError(PAGE_NAME, functionName, err);
    //   }
    // }

    const showViewModal = (key, attach) => {
      setShowView(!showView);
      setShowAttachment(attach);
    }

    const hideViewModal = () => {
        setShowView(!showView);
    }

    // useEffect(() => {
    //   responseData.map((data, index) => {
    //     // console.log(data.RESPONSE_DETAILS);
    //     if (responseAttachment[index] !== null && responseAttachment[index] !== undefined && responseAttachment[index].length > 0) {
    //       responseAttachment[index].map((attach, i) => {
    //         // console.log(responseAttachment[index])
    //         // console.log(attach)
    //       })      
    //     }     
    //   })
    // }, [ responseData, responseAttachment, userId])

    return(
      <>
        <div className={CssClass.Card}>
          <NewResponseCard 
              data={responseData} 
              responseAttachment={responseAttachment}
              showViewModal={showViewModal}
              authority={props.authority}      //pass authority
              reloadData={props.reloadData}    //pass reloadData
          />
          {/* {responseData.map((data, index) => {
            return(
                <NewResponseCard
                    key={index} 
                    data={data} 
                    index={index} 
                    responseAttachment={responseAttachment}
                    showViewModal={showViewModal}
                />
            )        
            // return (
            //   data.UPDATE_NAME === userName 
            //   ? (
            //     <Card key={index} style={{marginBottom: "1rem", marginLeft: "1rem"}}>
            //         <Card.Body style={{backgroundColor: "lightblue"}}>
            //             <Card.Text>
            //                 {data.RESPONSE_DETAILS}
            //             </Card.Text>
            //               <ResponseCard
            //                 key={index}
            //                 index={index}
            //                 responseAttachment={responseAttachment[index]}
            //                 owner={data.UPDATE_NAME === userName}
            //               />
            //         </Card.Body>
            //         <Card.Footer style={{backgroundColor: "#0F74DB", color: "white"}}>
            //             by {data.UPDATE_NAME} on {moment(data.UPDATE_DATETIME).format("DD/MM/YYYY hh:mm:ss A")}
            //         </Card.Footer>
            //     </Card>
            //   )
            //   :
            //   <Card key={index} style={{marginBottom: "1rem", marginRight: "1rem"}}>
            //     <Card.Body>
            //         <Card.Text>
            //             {data.RESPONSE_DETAILS}
            //         </Card.Text>
            //           <ResponseCard
            //             key={index}
            //             index={index}
            //             responseAttachment={responseAttachment[index]}
            //             owner={data.UPDATE_NAME === userName}
            //           />                 
            //     </Card.Body>
            //     <Card.Footer>
            //         by {data.UPDATE_NAME} on {moment(data.UPDATE_DATETIME).format("DD/MM/YYYY hh:mm:ss A")}
            //     </Card.Footer>
            // </Card>
            //   )
            })} */}
          </div> 
        </> 
    );
}

export default NewResponseChat;